import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from 'src/app/core/route.service';
import { SpOverviewComponent } from './sp-overview.component';

const routes: Routes = Route.withShell([
  { path: '', redirectTo: '/overview', pathMatch: 'full' },
  { path: 'overview', component: SpOverviewComponent, data: { title: 'Overview' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)]
  ],
  exports: [RouterModule],
  declarations: []
})
export class SpOverviewRoutingModule { }
